<script>
import ExportIcon from "@/icons/ExportIcon.vue";
import apiClient from "@/api/api-client";
import HeaderWrapper from "@/components/HeaderWrapper.vue";

export default {
  name: "VerifiersReportsList",
  components: { HeaderWrapper, ExportIcon },
  data() {
    return {
      reportType: "verifier",
      verifiersDate: null,
      verifiersList: [],
      loading: false,
    };
  },
  computed: {
    domain() {
      return window.domain;
    },
  },
  created() {
    this.getVerifiers();
  },
  methods: {
    toggleReport(type) {
      if (this.reportType !== type) {
        this.reportType = type;
        this.getVerifiers();
      }
    },
    changeVerifiersFilter() {
      this.getVerifiers();
    },
    async getVerifiers() {
      this.loading = true;
      try {
        let params = {};
        if (this.verifiersDate && this.verifiersDate.length > 0) {
          params.start_date = this.verifiersDate[0];
          params.stop_date = this.verifiersDate[1];
        }
        const url =
          this.reportType === "verifier"
            ? "/export/verifier"
            : "/export/verifier/all";
        const response = await apiClient.get(url, {
          params,
        });
        if (response && response.data) {
          this.verifiersList = response.data.data || [];
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async downloadReport(endpoint, params = {}) {
      this.loading = true;
      try {
        const data = await apiClient.post(endpoint, params);

        if (data && data.data && data.data.output_path) {
          const fileUrl = `${this.domain}${data.data.output_path}`;
          this.downloadFile(data.data.file_name, fileUrl);
        } else {
          alert("Не успешно");
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    downloadFile(filename, fileUrl) {
      fetch(fileUrl)
        .then((response) => response.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);

          const a = document.createElement("a");
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async downloadVerifiersReport() {
      const params =
        this.verifiersDate && this.verifiersDate[0] && this.verifiersDate[1]
          ? {
              start_date: this.verifiersDate[0],
              stop_date: this.verifiersDate[1],
            }
          : {};
      const url =
        this.reportType === "verifier"
          ? "/export/verifier"
          : "/export/verifier/all";
      await this.downloadReport(url, params);
    },
  },
};
</script>

<template>
  <div class="flex flex-col h-full w-full">
    <div class="border-0 border-b border-gray-200 border-solid">
      <HeaderWrapper
        ref="header-wrapper"
        :show-footer="false"
        :show-filter="false"
        :show-field="true"
      >
        <template #header>
          <div class="px-6">
            <div
              class="flex rounded-lg overflow-hidden bg-gray-100 border border-gray-200"
            >
              <button
                :class="[
                  'w-32 px-4 py-1.5 text-sm font-medium transition-all duration-150 focus:outline-none',
                  reportType === 'verifier'
                    ? 'text-white shadow-sm'
                    : 'text-gray-700 hover:bg-gray-200',
                ]"
                :style="
                  reportType === 'verifier' ? 'background-color: #4D8DFF;' : ''
                "
                @click="toggleReport('verifier')"
              >
                Верификаторы
              </button>

              <button
                :class="[
                  'w-32 px-4 py-1.5 text-sm font-medium transition-all duration-150 focus:outline-none border-l border-gray-200',
                  reportType === 'all'
                    ? 'text-white shadow-sm'
                    : 'text-gray-700 hover:bg-gray-200',
                ]"
                :style="
                  reportType === 'all' ? 'background-color: #4D8DFF;' : ''
                "
                @click="toggleReport('all')"
              >
                Все отчёты
              </button>
            </div>
          </div>
        </template>
        <template #field>
          <div class="py-3.5 w-full flex justify-end items-center px-5">
            <el-date-picker
              v-model="verifiersDate"
              value-format="YYYY-MM-DD"
              type="daterange"
              placeholder="Дата"
              style="max-width: 200px; margin-right: 10px"
              @change="changeVerifiersFilter"
            ></el-date-picker>
            <el-button
              @click="downloadVerifiersReport"
              :disabled="loading"
              type="success"
              plain
              class="download_button"
            >
              <export-icon></export-icon>
              Скачать xlsx</el-button
            >
          </div>
        </template>
      </HeaderWrapper>
    </div>
    <div class="flex flex-col w-full p-6 flex-1 min-h-0 overflow-hidden">
      <el-table
        :data="verifiersList"
        v-loading="loading"
        border
        stripe
        height="100%"
        style="width: 100%; overflow-y: auto"
      >
        <el-table-column
          type="index"
          label="№"
          width="70"
          align="center"
          fixed="left"
        ></el-table-column>
        <el-table-column
          prop="display_name"
          label="Верификатор"
          min-width="240"
        ></el-table-column>
        <el-table-column
          prop="count"
          label="Верифицировано файлов"
          width="240"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="total_duration"
          label="Верифицировано часов"
          width="240"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="total_spent"
          label="Затрачено часов"
          width="150"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="rtf"
          label="RTF"
          width="150"
          align="center"
        ></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<style scoped lang="scss">
::v-deep(.el-table__header th.el-table__cell) {
  @apply bg-gray-50 text-gray-600;
}
</style>
